import React from 'react';

import {
  ModalHeader,
  ModalDescription,
  ModalFooter,
  ModalTitle
} from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import { Form } from '@epoch-ui/components/Form';
import { QuestionnaireFields } from '@epoch-components/QuestionnaireFields';
import { StepBar } from '@epoch-components/step-bar/StepBar';
import {
  QuestionnaireFormValues,
  useQuestionResponseForm
} from '@epoch-components/QuestionnaireFields/schema';

import { useRSVPControlModalContext } from '../rsvpControlContext';

export const SubmitQuestionnaireModalContent: React.FC = () => {
  const formId = React.useId();
  const {
    navigation,
    guest: { firstName },
    event: { preEventQuestions: questions },
    updatedResponses: responses,
    setUpdatedResponses
  } = useRSVPControlModalContext();
  const fieldName = 'questionnaireResponses';
  const { form, parseResponses } = useQuestionResponseForm({
    fieldName,
    questions,
    responses
  });

  const handleSubmission = async (formValues: {
    questionnaireResponses: QuestionnaireFormValues;
  }): Promise<void> => {
    const isValid = await form.trigger('questionnaireResponses');
    if (!isValid) return;

    const updatedResponses = parseResponses(formValues);
    setUpdatedResponses(updatedResponses);
    navigation.onClickSubmit();
  };

  return (
    <>
      <ModalHeader className="tw-m-0 tw-flex tw-flex-col tw-gap-1">
        <ModalTitle className="tw-m-0 tw-text-2xl tw-font-medium">Submit Questionnaire</ModalTitle>
        <ModalDescription className="tw-m-0">{`You're editing ${firstName}'s questionnaire response`}</ModalDescription>
      </ModalHeader>
      <Form {...form}>
        <form
          id={formId}
          onSubmit={form.handleSubmit(handleSubmission)}
          className="tw-flex tw-flex-col tw-gap-6"
        >
          <QuestionnaireFields questions={questions} fieldNamePrefix={fieldName} />
        </form>
      </Form>
      <ModalFooter className="tw-mt-0 tw-flex tw-flex-row tw-justify-end">
        <div className="tw-flex tw-flex-1 tw-items-center">
          <StepBar
            totalSteps={navigation.totalStepNumber}
            currentStep={navigation.currentStepNumber}
          />
        </div>
        <div className="tw-flex tw-flex-row tw-justify-center tw-gap-4">
          <Button
            size="sm"
            onClick={navigation.onClickBack}
            className="tw-flex-1 tw-rounded-[8px]"
            variant="secondary"
          >
            Back
          </Button>
          <Button
            size="sm"
            className="tw-flex-1 tw-rounded-[8px]"
            variant="primary"
            type="submit"
            form={formId}
          >
            Update RSVP
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
